module.exports = __webpack_public_path__ + "static/media/MY.cd942bda.svg";